import React from 'react'
import { Upload, message } from 'antd'
import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import { parseFile, getConvertedCsvData, filterOutEmptyRecords, getUniqueRecords } from './importModel'

const Import = ({ uploaded }) => {
  const [loading, setLoading] = React.useState(false);
  const [convertedData, setConvertedData] = React.useState([]);


  const { Dragger } = Upload;

  React.useEffect(() => {
    if (convertedData.length > 0 && uploaded) {
      uploaded(convertedData)
    }
  })

  const customRequest = async ({
    file,
    onSuccess,
  }) => {
    const data = getUniqueRecords(filterOutEmptyRecords(await parseFile(file)))
    const convertedData = getConvertedCsvData(data, new Date())
    setConvertedData(convertedData)
    onSuccess({}, file)
    return {
      abort() {
        console.log('upload progress is aborted.');
      },
    };
  }

  const props = {
    name: 'file',
    multiple: false,
    action: '/bulkImport',
    customRequest: customRequest,
    onChange(info) {
      const { status } = info.file
      setLoading(status === 'uploading')
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  return <Dragger {...props}>
    <p className="ant-upload-drag-icon">
      {loading ? <LoadingOutlined /> : <InboxOutlined />}
    </p>
    <p className="ant-upload-text">Click or drag a CSV file to this area to upload</p>
    <p className="ant-upload-hint">
      Supported columns: Name, SKU, Cost, Class, Custom Margin, Custom Price, Tags, Categories
    </p>
  </Dragger>
}
export default Import
